import { useConfig } from '@/hooks/useConfig';

const { CLS_PRE } = useConfig();

export { CLS_PRE };
